import * as React from "react";

function PrintIcon(props) {
	return (
		<svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M128 0C110.3 0 96 14.3 96 32v96h64V64H384v64h64V32c0-17.7-14.3-32-32-32H128zM384 320H128v128H384V320zm64 64h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
    </svg>
	);
}

export default PrintIcon;
